export default {
  methods: {

    validateRequestAsDraft () {
      this.swalConfirm({
        html: () => {
          if (this.editing) {
            return 'Update changes on this Draft?'
          }

          return 'Save Stock Transfer as Draft?'
        },
        customClass: {
          confirmButton: 'btn btn-sm btn-secondary'
        },
        preConfirm: () => {
          const createOrUpdate = () => {
            return this.editing ? this.updateDraft() : this.submitDraft()
          }

          return createOrUpdate().catch(
            errors => {
              if (errors.errors) {
                this.setProductErrors(errors.errors)
                this.$refs.formDelivery.setErrors(errors.errors)
                this.$refs.formStockRequest.setErrors(errors.errors)
              }
            }
          )
        },
        confirmButtonText: this.editing ? 'Update' : 'Save'
      })
    },

    submitDraft () {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srDraft.create({
        id: id,
        headers: {
          origin: headers.origin,
          origin_name: headers.origin_name,
          origin_code: headers.origin_code,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          customer_direct: delivery_details.customer_direct,
          remarks: ''
        },
        delivery_details: {
          date: delivery_details.date,
          vehicle: '',
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver: '',
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: 1,
        active: 1
      }).then(() => {
        this.currentTabIndex = 1
      })
    },

    updateDraft (isDraft = 1, remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srDraft.update({
        id: id,
        headers: {
          origin: headers.origin,
          origin_name: headers.origin_name,
          origin_code: headers.origin_code,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          customer_direct: delivery_details.customer_direct,
          remarks: remarks
        },
        delivery_details: {
          customer: delivery_details.customer,
          mobile_number: delivery_details.mobile_number,
          address: delivery_details.address
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: isDraft,
        active: 1
      }).then(() => {
        this.currentTabIndex = Number(isDraft)
      })
    }
  }
}
